import { AppError } from "./AppError";
import { PLAID_ERROR_CODE } from "./errorParser";

/**
 * Возвращает строку ошибки для отображения пользователю.
 * - 500+: "Server error. Please try again later." (кроме 502 plaid_error — там текст Plaid)
 * - 400-499: сообщение из API (уже распаршено parseApiError)
 * - Остальные случаи: err.message или fallback
 */
export function getErrorMessage(
  err: unknown,
  fallback = "Something went wrong. Please try again."
): string {
  if (err instanceof AppError) {
    if (err.statusCode && err.statusCode >= 500 && err.code !== PLAID_ERROR_CODE) {
      return "Server error. Please try again later.";
    }
    return err.message || fallback;
  }

  if (err instanceof Error) {
    return err.message || fallback;
  }

  return fallback;
}
